<template>
  <div style="padding:20px;">
    <el-row :gutter="20">
      <el-skeleton :loading="dataLoading" animated>
        <template slot="template">
          <div style="padding:0 10px 24px">
            <el-skeleton-item variant="h3" style="width:200px"/>
            <el-skeleton-item variant="p" style="margin: 15px 0 0 0" />
            <el-skeleton-item variant="p" style="margin: 15px 0 0 0" />
            <el-skeleton-item variant="p" style="margin: 15px 0 0 0" />
          </div>
        </template>
        <template>
          <el-col :span="24">
            <h2 style="margin-top: 0;">活动数据</h2>
          </el-col>
          <el-col :span="24">
            <el-row :gutter="20" style="border-radius: 4px">
              <el-col :span="4">
                <el-descriptions title="" :column="1" size="medium">
                  <el-descriptions-item label="活动来源用户">
                    <el-tooltip class="item" effect="dark" content="用户来源为 助力活动 的用户数量" placement="bottom">
                      <span>{{ backendData.activity_source_user }}</span>
                    </el-tooltip>
                  </el-descriptions-item>
                  <el-descriptions-item label="新用户助力人数">{{ backendData.assist_new_user }}</el-descriptions-item>
                </el-descriptions>
              </el-col>
              <el-col :span="4">
                <el-descriptions title="" :column="1" size="medium">
                  <el-descriptions-item label="新用户APP助力人数">{{ backendData.app_new_user }}</el-descriptions-item>
                  <el-descriptions-item label="新用户H5助力人数">{{ backendData.wap_new_user }}</el-descriptions-item>
                </el-descriptions>
              </el-col>
              <el-col :span="4">
                <el-descriptions title="" :column="1" size="medium">
                  <el-descriptions-item label="奖学金活动发起人次">{{ backendData.create_log }}</el-descriptions-item>
                  <el-descriptions-item label="奖学金有效发起人次">{{ backendData.create_valid_log }}</el-descriptions-item>
                </el-descriptions>
              </el-col>
              <el-col :span="4">
                <el-descriptions title="" :column="1" size="medium">
                  <el-descriptions-item label="奖学金活动参与总人次">
                    <el-tooltip class="item" effect="dark" content="抽奖总次数" placement="bottom">
                      <span>{{ backendData.lottery_log }}</span>
                    </el-tooltip>
                  </el-descriptions-item>
                  <el-descriptions-item label="奖学金活动参与总人数">
                    <el-tooltip class="item" effect="dark" content="抽奖总人数" placement="bottom">
                      <span>{{ backendData.lottery_people }}</span>
                    </el-tooltip>
                  </el-descriptions-item>
                </el-descriptions>
              </el-col>
              <el-col :span="4">
                <el-descriptions title="" :column="1" size="medium">
                  <el-descriptions-item label="奖学金激活成功总人数">{{ backendData.create_success_log }}</el-descriptions-item>
                  <el-descriptions-item label="奖学金活动助力总人次">{{ backendData.partake_log }}</el-descriptions-item>
                </el-descriptions>
              </el-col>
              <!-- <el-col :span="12">
                <el-descriptions title="" :column="1" direction="vertical" size="medium">
                  <el-descriptions-item label="福袋领取记录">
                    <el-descriptions title="" :column="8" size="medium" >
                      <template v-for="(item,index) in backendData.lock_bag_log">
                        <el-descriptions-item v-bind:key="index" :label="item.received_luck_bag"><b>{{item.num}}</b></el-descriptions-item>
                      </template>
                    </el-descriptions>
                  </el-descriptions-item>
                </el-descriptions>
              </el-col> -->
            </el-row>
            <el-divider></el-divider>
          </el-col>
        </template>
      </el-skeleton>
      <el-col :span="24">
        <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
          <el-tab-pane label="活动管理" name="dataList">
            <el-row style="margin-bottom: 10px;">
              <el-input class="search-el" clearable size="small" v-model="query.title" placeholder="活动标题"></el-input>
              <el-select class="search-el" clearable size="small" v-model="query.type" placeholder="活动类型">
                <el-option label="全部" value=""></el-option>
                <el-option label="领课程" value="1"></el-option>
                <el-option label="领会员" value="2"></el-option>
              </el-select>
              <el-select class="search-el" clearable size="small" v-model="query.status" placeholder="活动状态">
                <el-option label="全部" value=""></el-option>
                <el-option label="进行中【上架且在有效期】" value="2"></el-option>
                <el-option label="上架中" value="1"></el-option>
                <el-option label="已下架" value="0"></el-option>
              </el-select>
              <el-button type="primary" size="small" @click="getList()">查询</el-button>
              <el-button type="primary" size="small" @click="addActivity()">增加活动</el-button>
            </el-row>
            <el-table :data="listData" style="width: 100%" border  v-loading="listLoading" >
              <el-table-column prop="id" label="ID" width="70"></el-table-column>
              <el-table-column prop="title" label="标题" width="120"></el-table-column>
              <el-table-column label="类型" width="90">
                <template slot-scope="{row}">
                  <span>{{row.type == 1 ? "课程" : "会员"}}</span>
                </template>
              </el-table-column>
              <el-table-column label="期号" width="90">
                <template slot-scope="{row}">
                  <span>第{{row.stage}}期</span>
                </template>
              </el-table-column>
              <el-table-column label="时间" width="100">
                <template slot-scope="{row}">
                  <div>{{ row.start_at }}</div>
                  <div>{{ row.end_at }}</div>
                </template>
              </el-table-column>
              <el-table-column label="状态" width="90">
                <template slot-scope="{row}">
                  <span style="color:rgb(103, 194, 58)" v-if="row.status == 1">上架中</span>
                  <span style="color:#909399" v-else>已下架</span>
                </template>
              </el-table-column>
              <el-table-column label="奖金">
                <template slot-scope="{row}">
                  <div>奖金金额：<b>{{ row.bonus_amount }}</b></div>
                  <div>初始金额：<b>{{ row.initial_bonus_start }} ~ {{ row.initial_bonus_end }}</b></div>
                  <div>剩余难度：<b>{{ row.remaining_bonus }}</b></div>
                </template>
              </el-table-column>
              <el-table-column label="奖品信息">
                <template slot-scope="{row}">
                  <div>奖品ID：<b>{{ row.give_ids }}</b></div>
                  <div>奖品标题：{{ row.give_title }}</div>
                  <div>奖品描述：{{ row.give_intro }}</div>
                </template>
              </el-table-column>
              <!-- <el-table-column label="奖品图片" width="100">
                <template slot-scope="{row}">
                  <el-image style="width: 75px; height: 50px" :src="row.give_img_url" fit="cover" :preview-src-list="[row.give_img_url]"></el-image>
                </template>
              </el-table-column> -->
              <!-- <el-table-column label="奖品价格">
                <template slot-scope="{row}">
                  <div>奖品划线价：<b>{{ row.give_scribing_price }}</b></div>
                  <div>奖品价格：<b>{{ row.give_price }}</b></div>
                </template>
              </el-table-column> -->
              <el-table-column label="福袋">
                <template slot-scope="{row}">
                  <div>福袋ID：<b>{{ row.lucky_bag_ids }}</b></div>
                  <div>福袋优惠券ID：{{ row.lucky_bag_extra_ids }}</div>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="{row}">
                  <el-button type="primary" size="small" @click="updateAssist(row.id)">修改</el-button>
                  <template v-if="row.status == 1">
                    <el-button type="danger" size="small" @click="updateAssistOnline(row.id, 'offline')">下架</el-button>
                  </template>
                  <template v-else>
                    <el-button type="success" size="small" @click="updateAssistOnline(row.id, 'online')">上架</el-button>
                  </template>
                  <template v-if="row.status == 0">
                    <el-button type="danger" size="small" @click="assistDelete(row.id)">删除</el-button>
                  </template>
                    <copyLink :url="row.share_url" buttonName="推广" @click="handel(row.share_url)"></copyLink>
                </template>
              </el-table-column>
            </el-table>
            <el-row>
              <div class="block">
                <el-pagination background @current-change="getList" :current-page.sync="query.page" :page-size="query.limit"
                    layout="total, prev, pager, next, jumper" :total="total">
                </el-pagination>
              </div>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="活动数据" name="assistData">
            <el-table :data="assistDataList" style="width: 100%" border  v-loading="assistDataListLoading" >
              <el-table-column prop="id" label="ID" width="90"></el-table-column>
              <el-table-column prop="title" label="标题"></el-table-column>
              <el-table-column label="期号" width="90">
                <template slot-scope="{row}"> <span>第{{row.stage}}期</span> </template>
              </el-table-column>
              <el-table-column prop="create_user_log" label="发起人数"></el-table-column>
              <el-table-column prop="lottery_user_log" label="参与人数"></el-table-column>
              <el-table-column prop="partake_log" label="助力次数"></el-table-column>
              <el-table-column prop="create_success_log" label="成功人数"></el-table-column>
              <el-table-column prop="assist_new_user" label="拉新人数"></el-table-column>
              <el-table-column prop="app_new_user" label="APP新用户"></el-table-column>
              <el-table-column prop="received_luck_bag" label="福袋领取数"></el-table-column>
              <el-table-column prop="received_coupon_luck_bag" label="优惠券领取数"></el-table-column>
              <el-table-column prop="give_title" label="奖品名称"></el-table-column>
              <el-table-column prop="remaining_bonus" label="难度系数"></el-table-column>
            </el-table>
            <el-row>
              <div class="block">
                <el-pagination background @current-change="getAssistDataList" :current-page.sync="assistDataListquery.page" :page-size="assistDataListquery.limit"
                    layout="total, prev, pager, next, jumper" :total="total2">
                </el-pagination>
              </div>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="用户数据" name="userData">
            <el-row style="margin-bottom: 10px;">
              <el-select class="search-el" clearable size="small" v-model="query.level_id" placeholder="用户级别">
                <el-option label="全部" value="0"></el-option>
                <el-option v-for="(item,index) in userLevelList" :key="'level'+index" :label="item.name" :value="item.id"></el-option>
              </el-select>
              <el-select class="search-el" clearable size="small" v-model="query.create_platform" placeholder="发起终端">
                <el-option label="不限" value="0"></el-option>
                <el-option v-for="(item,index) in platformList" :key="'cp'+index" :label="item" :value="index"></el-option>
              </el-select>
              <el-select class="search-el" clearable size="small" v-model="query.platform" placeholder="用户来源">
                <el-option label="不限" value="0"></el-option>
                <el-option v-for="(item,index) in platformList" :key="'p'+index" :label="item" :value="index"></el-option>
              </el-select>
              <el-select class="search-el" clearable size="small" v-model="query.stage" placeholder="助学金期号">
                <el-option label="不限" value="0"></el-option>
                <el-option v-for="(item,index) in stageList" :key="'stage'+index" :label="(item.type == 1 ? '课程-' : '会员-') + '第' + item.stage + '期'" :value="item.type + '_' + item.stage"></el-option>
              </el-select>
              <el-button type="primary" size="small" @click="getUserDataList()">
                查询
              </el-button>
              <el-button type="success" size="small" @click="exportUserData()" style="margin-left: 10px;">
                导出
              </el-button>
            </el-row>
            <el-table :data="userDataList" style="width: 100%" border  v-loading="userDataListLoading" >
              <el-table-column prop="user_id" label="用户ID" width="90"></el-table-column>
              <el-table-column prop="nickname" label="用户昵称"></el-table-column>
              <el-table-column prop="level_name" label="会员级别"></el-table-column>
              <el-table-column label="是否代理商" align="center">
                <template slot-scope="{ row }">
                  <span style="color: #f56c6c;" v-if="row.is_agent == 1">是</span>
                  <span style="color: #67C23A;" v-else>否</span>
                </template>
              </el-table-column>
              <el-table-column label="发起终端" width="90">
                <template slot-scope="{row}"> <span>{{platformList[row.create_platform]}}</span> </template>
              </el-table-column>
              <el-table-column label="用户来源" width="90">
                <template slot-scope="{row}"> <span>{{platformList[row.platform]}}</span> </template>
              </el-table-column>
              <el-table-column prop="channel_item_name" label="推广位"></el-table-column>
              <el-table-column prop="lottery_num" label="成功邀请助力"></el-table-column>
              <el-table-column prop="new_user_num" label="新用户助力人数"></el-table-column>
              <el-table-column prop="use_lottery_num" label="抽奖次数"></el-table-column>
              <el-table-column prop="use_free_num" label="免费抽奖次数"></el-table-column>
              <el-table-column label="还需金额" width="90">
                <template slot-scope="{row}"> <span>{{row.bonus_amount - row.received_bonus}}</span> </template>
              </el-table-column>
              <el-table-column prop="created_at" label="注册时间"></el-table-column>
              <el-table-column prop="assist_id" label="助力ID" width="90"></el-table-column>
              <el-table-column prop="title" label="标题"></el-table-column>
              <el-table-column label="期号" width="90">
                <template slot-scope="{row}"> <span>第{{row.stage}}期</span> </template>
              </el-table-column>
            </el-table>
            
            <div style="margin-top:10px">
              <el-pagination background @current-change="getUserDataList" :current-page.sync="query.page" :page-size="query.limit"
                            layout="total, prev, pager, next, jumper" :total="userDataListTotal">
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="福袋数据" name="luckBagData">
            <el-row style="margin-bottom: 10px;">
              <el-date-picker size="small" v-model="lockBagQuery.start_at" value-format="yyyy-MM-dd" type="date" placeholder="领取起始时间" ></el-date-picker>
              <el-date-picker size="small" v-model="lockBagQuery.end_at" value-format="yyyy-MM-dd" type="date" placeholder="领取截止时间" ></el-date-picker>
              <el-button type="primary" size="small"  style="margin-left: 10px;" @click="getLockBagList()">
                查询
              </el-button>
              领取累计：{{lockBagListCount}}；新用户领取累计：{{lockBagListNewUserCount}}
            </el-row>
            <el-table :data="lockBagList" style="width: 100%" border  v-loading="lockBagListLoading" >
              <el-table-column prop="assist_id" label="活动ID" width="90"></el-table-column>
              <el-table-column prop="received_luck_bag" label="课程ID"></el-table-column>
              <el-table-column prop="course_name" label="课程"></el-table-column>
              <el-table-column prop="num" label="领取数量"></el-table-column>
              <el-table-column prop="new_user" label="新用户数量"></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="全部用户数据" name="allUserData">
            <el-row style="margin-bottom: 10px;">
              <el-select class="search-el" clearable size="small" v-model="allQuery.level_id" placeholder="用户级别">
                <el-option label="全部" value="0"></el-option>
                <el-option v-for="(item,index) in userLevelList" :key="'allLevel'+index" :label="item.name" :value="item.id"></el-option>
              </el-select>
              <el-select class="search-el" clearable size="small" v-model="allQuery.create_platform" placeholder="发起终端">
                <el-option label="不限" value="0"></el-option>
                <el-option v-for="(item,index) in platformList" :key="'allCp'+index" :label="item" :value="index"></el-option>
              </el-select>
              <el-select class="search-el" clearable size="small" v-model="allQuery.platform" placeholder="用户来源">
                <el-option label="不限" value="0"></el-option>
                <el-option v-for="(item,index) in platformList" :key="'allP'+index" :label="item" :value="index"></el-option>
              </el-select>
              <el-select class="search-el" size="small" v-model="allQuery.stage" placeholder="助学金期号">
                <el-option v-for="(item,index) in stageList" :key="'allStage'+index" :label="(item.type == 1 ? '课程-' : '会员-') + '第' + item.stage + '期'" :value="item.type + '_' + item.stage"></el-option>
              </el-select>
              <el-button type="primary" size="small" @click="getAllUserDataList()">
                查询
              </el-button>
              <el-button type="success" size="small" @click="exportAllUserData()" style="margin-left: 10px;">
                导出
              </el-button>
            </el-row>
            <el-table :data="allUserDataList" style="width: 100%" border  v-loading="allUserDataListLoading" >
              <el-table-column prop="user_id" label="用户ID" width="90"></el-table-column>
              <el-table-column prop="nickname" label="用户昵称"></el-table-column>
              <el-table-column prop="level_name" label="会员级别"></el-table-column>
              <el-table-column label="是否代理商" align="center">
                <template slot-scope="{ row }">
                  <span style="color: #f56c6c;" v-if="row.is_agent == 1">是</span>
                  <span style="color: #67C23A;" v-else>否</span>
                </template>
              </el-table-column>
              <el-table-column label="发起终端" width="90">
                <template slot-scope="{row}"> <span>{{platformList[row.create_platform]}}</span> </template>
              </el-table-column>
              <el-table-column label="用户来源" width="90">
                <template slot-scope="{row}"> <span>{{platformList[row.platform]}}</span> </template>
              </el-table-column>
              <el-table-column prop="channel_item_name" label="推广位"></el-table-column>
              <el-table-column prop="lottery_num" label="成功邀请助力"></el-table-column>
              <el-table-column prop="new_user_num" label="新用户助力人数"></el-table-column>
              <el-table-column prop="use_lottery_num" label="抽奖次数"></el-table-column>
              <el-table-column prop="use_free_num" label="免费抽奖次数"></el-table-column>
              <el-table-column label="还需金额" width="90">
                <template slot-scope="{row}"> <span>{{row.bonus_amount - row.received_bonus}}</span> </template>
              </el-table-column>
              <el-table-column prop="created_at" label="注册时间"></el-table-column>
              <el-table-column prop="assist_id" label="助力ID" width="90"></el-table-column>
              <el-table-column prop="title" label="标题"></el-table-column>
              <el-table-column label="期号" width="90">
                <template slot-scope="{row}"> <span>第{{row.stage}}期</span> </template>
              </el-table-column>
            </el-table>
            
            <div style="margin-top:10px">
              <el-pagination background @current-change="getAllUserDataList" :current-page.sync="allQuery.page" :page-size="allQuery.limit"
                            layout="total, prev, pager, next, jumper" :total="allUserDataListTotal">
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  getData, getList, getAssistDataList, getUserDataList, getLockBagList, updateAssistOnline, assistDelete
} from "@/api/activityAssist";
import { setTimeout } from 'timers';
import copyLink from "@/components/copymask.vue";

export default {
  data: function() {
    return {
      platformList:{
        0:'H5',
        1:'Android',
        2:'IOS',
        3:'H5',
      },
      userLevelList:[],
      stageList:[],
      query:{
        title: '',
        type: '',
        status: '',
        level_id:'',
        create_platform:'',
        platform:'',
        stage:'',
        page:1,
        limit:20,
      },
      activeName: 'dataList',
      dataLoading:true,
      listLoading:true,
      backendData:{
        activity_source_user: 0,
        app_new_user: 0,
        wap_new_user: 0,
        assist_new_user: 0,
        create_log: 0,
        create_success_log: 0,
        create_valid_log: 0,
        lottery_log: 0,
        lottery_people: 0,
        partake_log: 0,
        lock_bag_log:[],
      },
      listData:[],
      assistDataList:[],
      assistDataListLoading:true,
      userDataList:[],
      userDataListLoading:true,
      lockBagList:[],
      lockBagListCount:0,
      lockBagListNewUserCount:0,
      lockBagListLoading:true,
      userDataListTotal:0,
      lockBagQuery:{
        start_at:'',
        end_at:'',
      },
      /* query duplication removed */
      assistDataListquery:{
        page: 1,
        limit: 10,
      },
      total2:0,
      total:0,
      allUserDataList:[],
      allUserDataListLoading:true,
      allUserDataListTotal:0,
      allQuery:{
        level_id:'',
        create_platform:'',
        platform:'',
        stage:'',
        page:1,
        limit:20,
        is_all: 1,
      },
    };
  },
  created: function() {
    this.getData();
    this.getList();
  },
  components: {
    copyLink,
  },
  methods: {
    getData(){
      this.dataLoading = true;
      getData().then(response => {
        let that = this
        this.backendData = response.data.backend_data
        setTimeout(function(){
          that.dataLoading = false;
        }, 500);
      });
    },
    handel(url){
      console.log(url);
    },
    getList(){
      this.listLoading = true;
      getList(this.query).then(response => {
        this.listData = response.data.list
        this.listLoading = false;
        this.total = response.data.total
        if (this.query.page > Math.ceil(this.total / this.query.limit)) {
              this.query.page = 1;
              this.fetchData();
          }
      });
    },
    fetchData(){
      this.getList()
    },
    getAssistDataList(){
      this.assistDataListLoading = true;
      getAssistDataList(this.assistDataListquery).then(response => {
        this.assistDataList = response.data.list
        this.assistDataListLoading = false;
        this.total2 = response.data.total
      });
    },
    getUserDataList(){
      this.userDataListLoading = true;
      getUserDataList(this.query).then(response => {
        this.userDataList = response.data.list
        this.userLevelList = response.data.user_level_list
        this.stageList = response.data.stage_list
        this.userDataListTotal = response.data.total;
        this.userDataListLoading = false;
      });
    },
    exportUserData() {
      this.userDataListLoading = true;
      let exportQuery = JSON.parse(JSON.stringify(this.query));
      exportQuery.page = 1;
      exportQuery.limit = 100000;
      getUserDataList(exportQuery).then(response => {
        let list = response.data.list;
        if (!list || list.length === 0) {
            this.$message.warning('没有可导出的数据');
            this.userDataListLoading = false;
            return;
        }
        let str = "用户ID,用户昵称,会员级别,是否代理商,发起终端,用户来源,推广位,成功邀请助力,新用户助力人数,抽奖次数,免费抽奖次数,还需金额,注册时间,助力ID,标题,期号\n";
        for(let i=0; i<list.length; i++) {
            let row = list[i];
            let is_agent = row.is_agent == 1 ? '是' : '否';
            let pt1 = this.platformList[row.create_platform] || '';
            let pt2 = this.platformList[row.platform] || '';
            let cost = row.bonus_amount - row.received_bonus;
            let stage = `第${row.stage}期`;
            
            str += `"${row.user_id}","${row.nickname}","${row.level_name}","${is_agent}","${pt1}","${pt2}","${row.channel_item_name}","${row.lottery_num}","${row.new_user_num}","${row.use_lottery_num}","${row.use_free_num}","${cost}","${row.created_at}","${row.assist_id}","${row.title}","${stage}"\n`;
        }
        let blob = new Blob(["\ufeff" + str], {type: 'text/csv;charset=utf-8;'});
        let link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "用户数据.csv";
        link.click();
        this.userDataListLoading = false;
      }).catch(() => {
        this.userDataListLoading = false;
        this.$message.error('导出失败');
      });
    },
    getAllUserDataList(){
      this.allUserDataListLoading = true;
      getUserDataList(this.allQuery).then(response => {
        this.userLevelList = response.data.user_level_list
        this.stageList = response.data.stage_list
        // 默认选中第一期，且如果有变化重新请求
        if (this.allQuery.stage === '' && this.stageList && this.stageList.length > 0) {
          this.allQuery.stage = this.stageList[0].type + '_' + this.stageList[0].stage;
          this.getAllUserDataList();
          return;
        }
        this.allUserDataList = response.data.list
        this.allUserDataListTotal = response.data.total;
        this.allUserDataListLoading = false;
      });
    },
    exportAllUserData() {
      this.allUserDataListLoading = true;
      let exportQuery = JSON.parse(JSON.stringify(this.allQuery));
      exportQuery.page = 1;
      exportQuery.limit = 100000;
      getUserDataList(exportQuery).then(response => {
        let list = response.data.list;
        if (!list || list.length === 0) {
            this.$message.warning('没有可导出的数据');
            this.allUserDataListLoading = false;
            return;
        }
        let str = "用户ID,用户昵称,会员级别,是否代理商,发起终端,用户来源,推广位,成功邀请助力,新用户助力人数,抽奖次数,免费抽奖次数,还需金额,注册时间,助力ID,标题,期号\n";
        for(let i=0; i<list.length; i++) {
            let row = list[i];
            let is_agent = row.is_agent == 1 ? '是' : '否';
            let pt1 = this.platformList[row.create_platform] || '';
            let pt2 = this.platformList[row.platform] || '';
            let cost = row.bonus_amount - row.received_bonus;
            let stage = `第${row.stage}期`;
            
            str += `"${row.user_id}","${row.nickname}","${row.level_name}","${is_agent}","${pt1}","${pt2}","${row.channel_item_name}","${row.lottery_num}","${row.new_user_num}","${row.use_lottery_num}","${row.use_free_num}","${cost}","${row.created_at}","${row.assist_id}","${row.title}","${stage}"\n`;
        }
        let blob = new Blob(["\ufeff" + str], {type: 'text/csv;charset=utf-8;'});
        let link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "全部用户数据.csv";
        link.click();
        this.allUserDataListLoading = false;
      }).catch(() => {
        this.allUserDataListLoading = false;
        this.$message.error('导出失败');
      });
    },
    updateAssist(id){
      this.$router.push({
        path: "/activity/assist/info",
        query: {type:'update', id:id}
      });
    },
    addActivity(){
      this.$router.push({
        path: "/activity/assist/info",
        query: {type:'create'}
      });
    },
    getLockBagList(){
      this.lockBagListLoading = true;
      getLockBagList(this.lockBagQuery).then(response => {
        this.lockBagList = response.data.list
        this.lockBagListCount = response.data.count
        this.lockBagListNewUserCount = response.data.new_user_count
        this.lockBagListLoading = false;
      });
    },
    updateAssistOnline(id,type){
      this.listLoading = true;
      updateAssistOnline({id,type}).then(response => {
        this.listLoading = false;
        if(response.code == 1){
          this.getList();
          this.$message({
            showClose: true,
            duration: 6000,
            message: '修改成功',
            type: 'success'
          });
        }
      });
    },
    assistDelete(id){
      this.$confirm('此操作将删除活动信息，是否确认操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.listLoading = true;
        assistDelete({id}).then(response => {
          this.listLoading = false;
          if(response.code == 1){
            this.getList();
            this.$message({
              showClose: true,
              duration: 6000,
              message: '删除成功',
              type: 'success'
            });
          }
        });
      }).catch(() => {

      });
      
    },
    handleClick(tab) {
      switch (tab.name) {
        case 'dataList':
          this.getList();
          break;
        case 'assistData':
          this.getAssistDataList();
          break;
        case 'userData':
          this.getUserDataList();
          break;
        case 'luckBagData':
          this.getLockBagList();
          break;
        case 'allUserData':
          this.getAllUserDataList();
          break;
      }
    },
  }
};
</script>

